import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { QuickDialog } from '../utilities/Dialog/QuickDialog';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'tracker',
  templateUrl: './tracker.component.html',
  styleUrls: ['./tracker.component.css']
})
export class TrackerComponent implements OnInit {

  location = false;
  onRatingClosed:EventEmitter<any> = new EventEmitter<any>();
  copied;
  @Input() data;
  constructor(private dialog:MatDialog) { }

  ngOnInit() {
    console.log(this.data)
  }

  getClass(status) {
    if (this.data && this.data.state === 'COMPLETED' && this.data.steps) {
      // Only the last step should pulse
      if (this.data.steps[this.data.steps.length - 1] === status) {
        return 'status active';
      }
      return 'status';
    }
    if (status && status.active) {
      return 'status active';
    }
    return 'status';
  }

  onLocation(){
    this.location = true;
  }

  copyToClipboard() {
    var nav : any = navigator;
    nav.clipboard.writeText(this.data.tripid).then(() => {
      this.copied = true;
      setTimeout(() =>{
        this.copied = false;
      },2000);
      console.log('Link Copied');
    }).catch(err => {
      console.error('Failed to copy text: ', err);
    });
  }

  call(){
    window.location.href = `tel:${this.data.driverphone}`;
  }

  openRating(){
    new QuickDialog(this.dialog).DeliveryRatingDialog({
      tripid:this.data.tripid
    }).then((res) =>{
      window.location.reload();
      this.onRatingClosed.emit();
    })
  }
  

}



// WEBPACK FOOTER //
// ./src/app/tracker/tracker.component.ts